// extracted by mini-css-extract-plugin
export var closeButton = "_14-5";
export var container = "_14-0";
export var contentContainer = "_14-1";
export var desktop = "_14-2";
export var fullModalImage = "_14-6";
export var mobile = "_14-3";
export var withImage = "_14-4";